"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaretDown = void 0;
const react_1 = __importDefault(require("react"));
const CaretDown = ({ fill = "none" }) => {
    if (fill === "filled") {
        return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 256 256", width: "100%", height: "100%" },
            react_1.default.createElement("path", { fill: "currentColor", d: "M215.39,92.94A8,8,0,0,0,208,88H48a8,8,0,0,0-5.66,13.66l80,80a8,8,0,0,0,11.32,0l80-80A8,8,0,0,0,215.39,92.94Z" })));
    }
    return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 22 12", fill: "none", "aria-hidden": true },
        react_1.default.createElement("path", { d: "M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L11 9.58579L20.2929 0.292893C20.6834 -0.0976311 21.3166 -0.0976311 21.7071 0.292893C22.0976 0.683417 22.0976 1.31658 21.7071 1.70711L11.7071 11.7071C11.3166 12.0976 10.6834 12.0976 10.2929 11.7071L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z", fill: "currentColor" })));
};
exports.CaretDown = CaretDown;
//# sourceMappingURL=caret-down.js.map